import React, { useCallback } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { Card, List } from "semantic-ui-react"
import Loader from "../../BifrostPageComponent/Loader/Loader"

const BifrostList = ({ list }) => {
	const nav = useNavigate()
	const { pathname, state } = useLocation()

	const handleListClick = (list, element) => {
		if (list.tab) {
			nav(list.path + element.id, { state: { ...state, lastPath: pathname, tab: list.tab } })
		} else {
			nav(list.path + element.id, { state: { ...state, lastPath: pathname, tab: null } })
		}
	}

	const compileStructure = useCallback((lists) =>
		lists.map(
			(element, index) =>
				element.type === "unassigned" && !element.children ? null : (
					<List.Item key={index} className={element.type} onClick={() => handleListClick(list, element)}>
						<List.Content floated="right">{element.listHandler && element.listHandler}</List.Content>
						{element.icon}
						<List.Content>
							<List.Header>{element.name}</List.Header>
						</List.Content>
						{element.children && <List.List>{compileStructure(element.children)}</List.List>}
					</List.Item>
				),
			[lists]
		)
	)

	return (
		<Card fluid>
			<Card.Content>
				<List relaxed>
					<List.Item>
						<List.Content floated="right">{list.operationButton}</List.Content>
						<List.Content>
							<List.Header as="h3">
								{list.icon}
								<span style={{ marginLeft: "0.5rem" }}>{list.name}</span>
							</List.Header>
							{!list.isloading &&
								(list.description ? (
									<List.Description>
										In total: {list.description} {list.name}
									</List.Description>
								) : (
									<List.Description style={{ marginTop: "1rem" }}>
										{list.isError && list.errorMessage ? list.errorMessage : `There are currently no ${list.name} in this ${list.struct}.`}
									</List.Description>
								))}
						</List.Content>
					</List.Item>
					<List.Item>
						{list.isloading ? (
							<Loader backgroundColor="white" inverted height="1px" minHeight="100px" />
						) : (
							<List content={compileStructure(list.content)} animated={list.path ? true : false} selection={list.path ? true : false} />
						)}
					</List.Item>
				</List>
			</Card.Content>
		</Card>
	)
}

export default BifrostList
